import React, { useEffect, useState } from 'react'
import Sidebar from '../components/sidebar';
import Topbar from '../components/topbar';
import Button from 'react-bootstrap/Button';
import { Modal} from 'react-bootstrap';
import Pagination from "../components/Pagination";
import axios from "../axiosInstance";
import { useNavigate } from 'react-router-dom';
import { errorMessage } from '../hooks/UserLogs';
import * as XLSX from "xlsx";

export default function BillerPerAgent() {
    const [totalPage, setTotalPage] = useState(1)
    const [currentPage, setCurrentPage] = useState(1)
    const [ListUserLogs, setListUserLogs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [ListAgents, setListAgents] = useState([]);
    const [ListAgencies, setListAgencies] = useState([]);
    const [errMsg, setErrorMsg] = useState("Une erreure s'est produite!!");
    const [showError, setShowError] = useState(false);
    const [statusTransaction, setStatusTransaction] = useState('P');
    const convertToDate=(resultDate)=>{
        const yyyy = resultDate.getFullYear();
        let mm = resultDate.getMonth(); // Months start at 0!
        let dd = resultDate.getDate();
        mm=mm+1;
        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;
        return yyyy+'-'+mm+'-'+dd+'T00:00:00.000Z';
    }
    let defaultBgDate = new Date()
    defaultBgDate.setDate(defaultBgDate.getDate() - 7)
    let defaultEndDate = new Date()
    defaultEndDate.setDate(defaultEndDate.getDate() +1)
    const [beginDate,setBeginDate]=useState(defaultBgDate);
    const [endDate,setEndDate]=useState(defaultEndDate);
    const [idAgent,setIdAgent]=useState("");
    const [idAgency,setIdAgency]=useState("");
    
    const axiosInstance = axios.create({
      withCredentials: true,
    })
    
    let header =
    {
      'Content-Type': 'application/json'
    };

    const navigate = useNavigate();
    const bUrl = process.env.REACT_APP_B_URL;
    const getListAgents = async () => {
      let ulr = "/customer-wallet/find-all-agents?page=" + 1 + "&limit=1000000";
     
      const response = await axiosInstance.get(bUrl + ulr).catch((err) => {
        console.error(err);
        setIsLoading(false)
  
      });
      if (response) {
        
        if (response?.data?.isError) {
          const msg = errorMessage(response?.data?.code)
          setErrorMsg(msg);
          setShowError(true);
        }else{
          setListAgents(response.data.body);
        }
        
        if (response.status == 401) {
          navigate('/backoffice/login');
        }
        
        setIsLoading(false)
      }
    }

    const dataToExcel = async()=>{
      let bgDateConvert=convertToDate(new Date(beginDate));
        let endDateConvert=convertToDate(new Date(endDate));
        let ulr = "/biller-invoice/biller-by-agent-Sum-biller-amount?page=1&limit="+10*totalPage+"&begenDate="+bgDateConvert+"&endDate="+endDateConvert+"&status="+statusTransaction;
        if (idAgent!= '') {
            ulr+="&idAgent="+idAgent;
        }

        if (idAgency!= '') {
          ulr+="&fkIdAgency="+idAgency;
        }
       
        const response = await axiosInstance.get(bUrl + ulr).catch((err) => {
          
          if (err?.response?.status == 401 || err?.response?.status == 403) {
            setErrorMsg("Vous n'étes pas autorisé à faire cette opération!!")
            setShowError(true);
          }else{
            let msg=errMsg+ ' ' +err?.response?.status?(err?.response?.status):'';
            setErrorMsg(msg);
            setShowError(true);
          }

          setIsLoading(false)
    
        });

        if (response) {
          
          if (response?.data?.isError) {
            const msg = errorMessage(response?.data?.code)
            setErrorMsg(msg);
            setShowError(true);
          }else{
            //console.log(response.data.body)
            //setListUserLogs(response.data.body);
            //setTotalPage(response.data.totalPage);
            //setCurrentPage(response.data.currentPage);

            const filterListAgent=response.data.body.map(({firstName,middleName,lastName,phone,agency,totalBillerAmount,count})=>({
              Nom:firstName + ' ' + middleName+ ' ' + lastName,
              Telephone: phone,
              Agence: agency,
              Nombre:count,
              Total: totalBillerAmount,
            }))
      
            const ws = XLSX.utils.json_to_sheet(filterListAgent);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Marchand");
            XLSX.writeFile(wb, "Marchand_Facture.xlsx");
          }
        }

      
    }
    
     const getListAgencies = async () => {
        let ulr = "/agencies?page=" + 1 + "&limit=10";
    
    
        const response = await axiosInstance.get(bUrl + ulr).catch((err) => {
          console.log(err);
          setIsLoading(false)
    
        });
        if (response) {
          if (response?.data?.isError) {
            const msg = errorMessage(response?.data?.code)
            setErrorMsg(msg);
            setShowError(true);
          }else{
            setListAgencies(response.data.body);
          }
    
          setIsLoading(false);
        }
      }
    const getBillerPerAgent = async (bgDate,edDate,idAgent,idAgency) => {
        setBeginDate(new Date(bgDate));
        setEndDate(new Date(edDate));
        setIdAgent(idAgent);
        setIdAgency(idAgency);
        let bgDateConvert=convertToDate(new Date(bgDate));
        let endDateConvert=convertToDate(new Date(edDate));
        setIsLoading(true);
        let ulr = "/biller-invoice/biller-by-agent-Sum-biller-amount?page=" + currentPage + "&limit=10&begenDate="+bgDateConvert+"&endDate="+endDateConvert+"&status="+statusTransaction;
        if (idAgent!= '') {
            ulr+="&idAgent="+idAgent;
        }

        if (idAgency!= '') {
          ulr+="&fkIdAgency="+idAgency;
        }
       
        const response = await axiosInstance.get(bUrl + ulr).catch((err) => {
          
          if (err?.response?.status == 401 || err?.response?.status == 403) {
            setErrorMsg("Vous n'étes pas autorisé à faire cette opération!!")
            setShowError(true);
          }else{
            let msg=errMsg+ ' ' +err?.response?.status?(err?.response?.status):'';
            setErrorMsg(msg);
            setShowError(true);
          }

          setIsLoading(false)
    
        });

        if (response) {
          
          if (response?.data?.isError) {
            const msg = errorMessage(response?.data?.code)
            setErrorMsg(msg);
            setShowError(true);
          }else{
           // console.log(response.data.body)
            setListUserLogs(response.data.body);
            setTotalPage(response.data.totalPage);
            setCurrentPage(response.data.currentPage);
          }

          setIsLoading(false);

        }
        
    }
   
    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "long", day: "numeric", hour: 'numeric', minute: 'numeric', second: 'numeric' }
        return new Date(dateString).toLocaleDateString(undefined, options)
      }
    const handleCloseError = () => {
        setShowError(false);
      }
      useEffect(()=>{
        if(sessionStorage.getItem("name")==='' ||sessionStorage.getItem("name")===null){
          //console.log("----------GO GO GO ------------")
          navigate('/backoffice/login');
        }
        getListAgencies();
        getListAgents();
        getBillerPerAgent(beginDate, endDate, idAgent,idAgency);

      },[currentPage]);

    return (
        <div className="App">
      <div className="">

        <Sidebar />
        <section className="home ">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              <div className="table-content mt-2 p-2 text d-flex justify-content-between">
                <div><p className='fw-bold'>Revenus des ventes d'electricité par marchand</p></div>
                <div><Topbar /></div>
              </div>
              <div className="table-content mt-3 p-3">
                <div className="d-flex justify-content-around">
                  <div className="form-group text">
                    <label htmlFor="exampleInputEmail1">Début</label>
                    <input type="Date" value={beginDate.toLocaleDateString('en-CA')} onChange={(e) => getBillerPerAgent(e.target.value, endDate, idAgent,idAgency)} className="form-control" id="exampleInputEmail1"  />
                  </div>
                  <div className="form-group text">
                    <label htmlFor="phone">Fin</label>
                    <input type="Date" value={endDate.toLocaleDateString('en-CA')} onChange={(e) => getBillerPerAgent(beginDate, e.target.value, idAgent,idAgency)} className="form-control" id="phone" aria-describedby="Phone" placeholder="Phone" />
                  </div>
                  <div className="form-group text">
                    <label htmlFor="code">Marchand</label>
                    <select className="form-select form-select-lg mb-3" aria-label=".form-select-lg example" value={idAgent}  onChange={(e) => getBillerPerAgent(beginDate, endDate,e.target.value,idAgency)}>
                          <option value="">Sélectionnez Marchand</option>
                          {ListAgents!=null?  ListAgents.length > 0 ? ListAgents.map((a, i) => {
                            return <option value={a.idCustomerWallet} key={i}>{a.firstName+" "+a.middleName +" "+a.lastName+" | "+a.phone}</option>
                          }
                          ):'':''}
                      </select>
                  </div>
                  <div className="form-group text">
                  <label htmlFor="code">Agence</label>
                  <select className="form-select form-select-lg mb-3" aria-label=".form-select-lg example" value={idAgency} onChange={(e) => getBillerPerAgent(beginDate, endDate,idAgent,e.target.value)}>
                            <option value="">Sélectionnez une Agence</option>
                            {ListAgencies != null ? ListAgencies.length > 0 ? ListAgencies.map((a, i) => {
                              return <option value={a.idAgency} key={i}>{a.name + " | " + a.code}</option>
                            }
                            ) : '' : ''}
                          </select>
                  </div>
                </div>
              </div>
              <div className="table-content mt-3 p-3">

              <div className="d-flex flex-row-reverse">
                <div>
                  <span onClick={() => dataToExcel()} className="clickable">
                    <i className='bx bx-printer bx-sm'></i>
                  </span>
                </div>
              </div>
                <div className="table-responsive-xl">
                  {isLoading ? <div className='loading'><img src='../Custom.svg' /></div> :
                    <table className="table text">
                      <thead>
                        <tr>

                          <th scope="col">N°</th>
                          <th scope="col">Nom</th>
                          <th scope="col">Téléphone</th>
                          <th scope="col">Agence</th>
                          <th scope="col">Nombre</th>
                          <th scope="col">Montant</th>
                          <th></th>
                          <th></th>

                        </tr>
                      </thead>

                      <tbody>
                        {ListUserLogs!=null?ListUserLogs.length > 0 ? ListUserLogs.map((a, i) => {
                          return <tr key={i}>
                            <td>{i}</td>
                            <td>{a.firstName+" "+a.middleName +" "+a.lastName}</td>
                            <td>{a.phone}</td>
                            <td>{a.agency}</td>
                            <td>{a.count}</td>
                            <td>{a.totalBillerAmount}</td>
                          </tr>
                        }) : <tr></tr>:''}
                      </tbody>

                    </table>
                  }
                </div>
                <Pagination totalPage={totalPage} setCurrentPage={setCurrentPage} currentPage={currentPage} />
                </div>

            </div>
          </div>
        </section>
      </div>
      

      {/* =============================================error=============================== */}
      <Modal show={showError} onHide={handleCloseError} className="">
        <Modal.Header closeButton className="bg-danger">
          <Modal.Title>ERROR</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className='text-danger' style={{ textAlign: 'center' }}>{errMsg}</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseError}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
    )
}
